import RadioMenuItem from '../DynamicMenuItems/RadioMenuItem';


export default function SettingsMenu(props) {
    return (
        <div>
            <RadioMenuItem
                onChange={props.onThemeChange}
                options={props.options}
                name='radio-themes'
                label='Theme' />
        </div>
    )
}